import renderingInServer from '@shared/renderingInServer';
import { isFunction } from 'lodash';

const noAccessToAnalytics = () => renderingInServer() || !window.analytics;

export const identify = (userEmail, params) => {
  if (noAccessToAnalytics()) return;

  window.analytics.identify(userEmail, params);
};

export const track = (event, params) => {
  if (noAccessToAnalytics()) return;

  window.analytics.track(event, params);
};

export const page = (pageName, params) => {
  if (noAccessToAnalytics()) return;

  window.analytics.page(pageName, params);
};

export const anonymousId = () => {
  if (noAccessToAnalytics()) return null;

  if (!isFunction(window.analytics.user)) return null;

  return window.analytics.user().anonymousId();
};
